import { RouteConfig } from 'vue-router';

import i18n from '@/i18n';
import Home from '@/views/home';
import Mollie from '@/views/mollie';
import StartMollie from '@/views/start-mollie';
import Login from '@/views/login';
import SetPassword from '@/views/set-password';
import ForgotPassword from '@/views/forgot-password';
import CreateCompany from '@/views/create-company';
import WeekOverview from '@/views/week-overview';
import NoSubscription from '@/views/no-subscription';

const Profile = () => import(/* webpackChunkName: "blocks" */ '@/views/profile');
const Appointments = () => import(/* webpackChunkName: "pages" */ '@/views/appointments');
const Admin = () => import(/* webpackChunkName: "admin" */ '@/views/admin');
const Settings = () => import(/* webpackChunkName: "settings" */ '@/views/settings');
const Statistics = () => import(/* webpackChunkName: "statistics" */ '@/views/statistics');
const Subscription = () => import(/* webpackChunkName: "subscription" */ '@/views/subscription');
const Users = () => import(/* webpackChunkName: "users" */ '@/views/users');

const routes: Array<RouteConfig> = [{
  path: '/',
  name: 'Home',
  component: Home,
  meta: {
    title: i18n.tc('home.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('home.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('home.meta.tags.description')
    }]
  }
}, {
  path: '/mollie/:id',
  name: 'Mollie',
  component: Mollie,
  meta: {
    title: i18n.tc('mollie.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('mollie.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('mollie.meta.tags.description')
    }]
  }
}, {
  path: '/starten/mollie/:id',
  name: 'Mollie Starten',
  component: StartMollie,
  meta: {
    title: i18n.tc('mollie.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('mollie.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('mollie.meta.tags.description')
    }],
    hideNav: true,
    public: true
  }
}, {
  path: '/appointments',
  name: 'Appointments',
  component: Appointments,
  meta: {
    title: i18n.tc('appointments.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('appointments.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('appointments.meta.tags.description')
    }]
  }
}, {
  path: '/admin',
  name: 'Admin',
  component: Admin,
  meta: {
    title: i18n.tc('admin.meta.title'),
    appAdmin: true,
    metaTags: [{
      name: 'description',
      content: i18n.tc('admin.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('admin.meta.tags.description')
    }]
  }
}, {
  path: '/profile',
  name: 'Profile',
  component: Profile,
  meta: {
    title: i18n.tc('profile.meta.title'),
    appAdmin: true,
    metaTags: [{
      name: 'description',
      content: i18n.tc('profile.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('profile.meta.tags.description')
    }]
  }
}, {
  path: '/subscription',
  name: 'Subscription',
  component: Subscription,
  meta: {
    title: i18n.tc('subscription.meta.title'),
    adminOnly: true,
    metaTags: [{
      name: 'description',
      content: i18n.tc('subscription.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('subscription.meta.tags.description')
    }],
  }
}, {
  path: '/users',
  name: 'Users',
  component: Users,
  meta: {
    title: i18n.tc('users.meta.title'),
    adminOnly: true,
    metaTags: [{
      name: 'description',
      content: i18n.tc('users.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('users.meta.tags.description')
    }],
  }
}, {
  path: '/week-overview',
  name: 'Week Overview',
  component: WeekOverview,
  meta: {
    title: i18n.tc('week_overview.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('week_overview.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('week_overview.meta.tags.description')
    }],
  }
}, {
  path: '/invalid-subscription',
  name: 'Invalid Subscription',
  component: NoSubscription,
  meta: {
    title: i18n.tc('no_subscription.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('no_subscription.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('no_subscription.meta.tags.description')
    }],
    hideNav: true,
  }
}, {
  path: '/settings',
  name: 'Settings',
  component: Settings,
  meta: {
    title: i18n.tc('settings.meta.title'),
    adminOnly: true,
    metaTags: [{
      name: 'description',
      content: i18n.tc('settings.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('settings.meta.tags.description')
    }]
  }
}, {
  path: '/statistics',
  name: 'statistics',
  component: Statistics,
  meta: {
    title: i18n.tc('stats.meta.title'),
    hasStats: true,
    metaTags: [{
      name: 'description',
      content: i18n.tc('settings.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('settings.meta.tags.description')
    }]
  }
}, {
  path: '/login',
  name: 'Login',
  component: Login,
  meta: {
    title: i18n.tc('login.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('login.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('login.meta.tags.description')
    }],
    hideNav: true,
    public: true,
  }
}, {
  path: '/set-password/:token',
  name: 'Set password',
  component: SetPassword,
  meta: {
    title: i18n.tc('set_password.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('set_password.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('set_password.meta.tags.description')
    }],
    hideNav: true,
    public: true,
  }
}, {
  path: '/forgot-password',
  name: 'Forgot password',
  component: ForgotPassword,
  meta: {
    title: i18n.tc('forgot_password.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('forgot_password.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('forgot_password.meta.tags.description')
    }],
    hideNav: true,
    public: true,
  }
}, {
  path: '/starten',
  name: 'Account aanmaken',
  component: CreateCompany,
  meta: {
    title: i18n.tc('create_company.meta.title'),
    metaTags: [{
      name: 'description',
      content: i18n.tc('create_company.meta.tags.description')
    }, {
      property: 'og:description',
      content: i18n.tc('create_company.meta.tags.description')
    }],
    hideNav: true,
    public: true,
  }
}, {
  path: '/home',
  redirect: '/',
}, {
  path: '*',
  redirect: '/',
}];

export default routes;
